module.exports = __webpack_public_path__ + "img/payroll-text-zh.6a60e65f.png";